import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]

import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '@/config/legal'


export default {
  __name: 'TermsAgreement',
  props: { action: { type: String, default: 'creating an account' } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("p", null, [
    _createTextVNode(" By " + _toDisplayString(__props.action) + ", you agree to Bottle Labs, Inc's ", 1),
    _createElementVNode("a", {
      href: _unref(TERMS_OF_SERVICE_URL),
      target: "_blank",
      rel: "noopener",
      class: "underline"
    }, "Terms of Service", 8, _hoisted_1),
    _cache[0] || (_cache[0] = _createTextVNode(" and ", -1)),
    _createElementVNode("a", {
      href: _unref(PRIVACY_POLICY_URL),
      target: "_blank",
      rel: "noopener",
      class: "underline"
    }, "Privacy Policy", 8, _hoisted_2),
    _cache[1] || (_cache[1] = _createElementVNode("span", null, ".", -1))
  ]))
}
}

}